import React, { useCallback } from "react";
import { LinkContainer } from "react-router-bootstrap";
import { UI } from "@wwimmo/ui";
import { useLocation } from "react-router-dom";
import { Route } from "src/config/routes";

interface NavigationbarItemProps {
    to: string;
    icon: React.ReactNode;
    label: string;
    disabled: boolean;
    onClick?: any;
}

export const NavigationbarItem = (props: NavigationbarItemProps) => {
    const location = useLocation();
    const pathname = location.pathname;

    const isCustomersActive =
        props.to === Route.customers &&
        (pathname === Route.customers || pathname.startsWith(`${Route.customers}/`)) &&
        !pathname.startsWith(Route.customersCopied) &&
        !pathname.startsWith(Route.customersCopy);

    const isCopiedCustomersActive =
        props.to === Route.customersCopied &&
        (pathname === Route.customersCopied || pathname.startsWith(`${Route.customersCopied}/`));

    const isDefaultActive =
        props.to !== Route.customers &&
        props.to !== Route.customersCopied &&
        (pathname === props.to || pathname.startsWith(`${props.to}/`));

    const isActive = isCustomersActive || isCopiedCustomersActive || isDefaultActive;
    const resolveIsActive = useCallback(() => isActive, [isActive]);

    return (
        <LinkContainer className="NavigationbarItem" to={props.to} isActive={resolveIsActive}>
            <UI.Nav.Link disabled={props.disabled} onClick={props.onClick} active={isActive}>
                <UI.Icon icon={props.icon} />
                <span className="d-none d-md-block ml-2">{props.label}</span>
            </UI.Nav.Link>
        </LinkContainer>
    );
};

NavigationbarItem.defaultProps = {
    disabled: false
};
